/* gr-carousel-nav — fleches + points + boucle "infinie" pour les carousels a scroll
   natif (overflow-x:auto). On branche via l'attribut data-gr-carousel sur la piste.
   - La nav ne s'affiche QUE si la piste scrolle (cachee sur desktop si tout est visible).
   - "Suivant" au bout -> revient au debut (et inversement) => sensation infinie.
   - Les points reflètent la position et permettent d'y sauter.
   Antoine 2026-06-29. */
(function () {
  function init(track) {
    if (track.__grNav) return;
    var cards = Array.prototype.filter.call(track.children, function (c) {
      return c.nodeType === 1;
    });
    if (cards.length < 2) return;
    track.__grNav = true;

    var nav = document.createElement('div');
    nav.className = 'gr-cnav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gr-cnav-arrow gr-cnav-prev';
    prev.setAttribute('aria-label', 'Precedent');
    prev.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gr-cnav-arrow gr-cnav-next';
    next.setAttribute('aria-label', 'Suivant');
    next.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'gr-cnav-dots';
    var dots = cards.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gr-cnav-dot';
      b.setAttribute('aria-label', 'Aller a l element ' + (i + 1));
      b.addEventListener('click', function () { scrollToCard(i); });
      dotsWrap.appendChild(b);
      return b;
    });

    nav.appendChild(prev);
    nav.appendChild(dotsWrap);
    nav.appendChild(next);
    track.parentNode.insertBefore(nav, track.nextSibling);

    function padLeft() {
      return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }
    function posOf(i) {
      var tr = track.getBoundingClientRect();
      var cr = cards[i].getBoundingClientRect();
      return Math.max(0, track.scrollLeft + (cr.left - tr.left) - padLeft());
    }
    // On coupe le scroll-snap pendant le scroll programmatique (sinon "mandatory"
    // ramène la piste au point de snap courant), on smooth-scrolle, puis on restaure
    // le snap via un timeout (robuste : ne depend pas de la fin de l'animation).
    function animateTo(target) {
      var max = track.scrollWidth - track.clientWidth;
      target = Math.max(0, Math.min(target, max));
      track.style.scrollSnapType = 'none';
      // Assignation directe (fiable partout) ; la fluidite vient du CSS
      // scroll-behavior:smooth pose sur la piste (anime sur les vrais appareils).
      track.scrollLeft = target;
      clearTimeout(track.__snapRestore);
      track.__snapRestore = setTimeout(function () {
        track.style.scrollSnapType = '';
      }, 700);
    }
    function scrollToCard(i) {
      animateTo(posOf(i));
    }
    function current() {
      var ref = track.getBoundingClientRect().left + padLeft();
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var dd = Math.abs(c.getBoundingClientRect().left - ref);
        if (dd < bestD) { bestD = dd; best = i; }
      });
      return best;
    }
    // Detection robuste (insensible au scroll-snap) basee sur la visibilite des
    // cartes extremes plutot que sur scrollLeft.
    function atEnd() {
      var tr = track.getBoundingClientRect();
      return cards[cards.length - 1].getBoundingClientRect().right <= tr.right + 8;
    }
    function atStart() {
      var tr = track.getBoundingClientRect();
      return cards[0].getBoundingClientRect().left >= tr.left - 8;
    }
    function cardStep() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function update() {
      var cur = current();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
      var scrollable = track.scrollWidth > track.clientWidth + 6;
      nav.style.display = scrollable ? 'flex' : 'none';
    }

    prev.addEventListener('click', function () {
      if (atStart()) animateTo(track.scrollWidth); // boucle -> fin
      else animateTo(track.scrollLeft - cardStep());
    });
    next.addEventListener('click', function () {
      if (atEnd()) animateTo(0); // boucle -> debut
      else animateTo(track.scrollLeft + cardStep());
    });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(update, 80);
    });
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(update, 160);
    });
    // La scrollabilite depend du layout final (images, largeurs de cartes). On
    // re-evalue apres load + via ResizeObserver + quelques delais, sinon la nav
    // reste cachee car scrollWidth est calcule trop tot.
    window.addEventListener('load', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        clearTimeout(t);
        t = setTimeout(update, 100);
      });
      ro.observe(track);
    }
    setTimeout(update, 400);
    setTimeout(update, 1500);
    update();
  }

  function boot() {
    var tracks = document.querySelectorAll('[data-gr-carousel]');
    Array.prototype.forEach.call(tracks, init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
